/*
 * Общие типы шагов курса. Каждый тип получает шаг (нейтральные данные +
 * `t` — текст языка) и api проигрывателя (course-kit.js), рисует себя в host
 * и сообщает ответ через api.answer({correct, score, reveal, explain}).
 * Доменные типы (доска, микрофон, клавиатура) живут в файлах курсов и
 * регистрируются тем же CourseKit.step(). Контракт полей — docs/courses.md.
 */
(function () {
    'use strict';
    var K = window.CourseKit;
    if (!K) return;

    function T(step) { return step.t || {}; }

    function prompt(host, api, text) {
        if (text) host.appendChild(api.richEl('p', 'crs-prompt', text));
    }

    /* Кнопка «Прослушать», если у шага есть звук: синтез нот или голос. */
    function audioButton(host, api, step) {
        var a = step.audio;
        if (!a) return null;
        var b = api.el('button', 'lg-btn lg-btn-ghost lg-btn-sm', '▶ ' + api.t('listen'));
        b.type = 'button';
        function play() {
            if (a.kind === 'notes') return api.tone(a.notes || [], { mode: a.mode, bpm: a.bpm, dur: a.dur, strum: a.strum });
            if (a.kind === 'tts') return api.say(T(step).say || T(step).prompt || '', a.lang, { rate: a.rate });
            return Promise.resolve();
        }
        b.addEventListener('click', function () {
            b.disabled = true;
            Promise.resolve(play()).catch(function () {}).then(function () { b.disabled = false; });
        });
        var row = api.el('div', 'crs-acts');
        row.appendChild(b);
        host.appendChild(row);
        if (a.autoplay) setTimeout(function () { if (api.alive()) b.click(); }, 250);
        return b;
    }

    function tipsBox(host, api, tips) {
        if (!tips || !tips.length) return;
        var box = api.el('div', 'crs-tips');
        box.appendChild(api.el('span', 'crs-k', '💡 ' + api.t('tip')));
        var ul = api.el('ul');
        tips.forEach(function (x) { ul.appendChild(api.richEl('li', null, x)); });
        box.appendChild(ul);
        host.appendChild(box);
    }
    function noteBox(host, api, note) {
        if (!note) return;
        var box = api.el('div', 'crs-note');
        box.appendChild(api.el('span', 'crs-k', '⚠️ ' + api.t('note')));
        box.appendChild(api.richEl('div', null, note));
        host.appendChild(box);
    }

    /* ── теория ─────────────────────────────────────────────────────── */
    K.step('read', {
        graded: false,
        mount: function (host, step, api) {
            var t = T(step);
            if (t.title) host.appendChild(api.el('h3', null, t.title));
            api.figure(host);
            api.body(host, t.body || []);
            audioButton(host, api, step);
            tipsBox(host, api, t.tips);
            noteBox(host, api, t.note);
            api.primary(api.t('next'), function () { api.answer({ correct: null }); });
        }
    });

    /* ── выбор: один верный (answer: число) или несколько (answer: массив) ── */
    function choiceMount(host, step, api) {
        var t = T(step);
        var opts = t.options || [];
        var multi = Array.isArray(step.answer);
        var right = multi ? step.answer.slice() : [step.answer];
        prompt(host, api, t.prompt);
        api.figure(host);
        audioButton(host, api, step);
        if (multi) host.appendChild(api.el('p', 'crs-hint', api.t('multi_hint')));
        var order = opts.map(function (_, i) { return i; });
        if (step.shuffle !== false) order = api.shuffle(order);
        var list = api.el('div', 'crs-opts');
        var buttons = [];
        var picked = {};
        order.forEach(function (oi, pos) {
            var b = api.el('button', 'crs-opt');
            b.type = 'button';
            b.setAttribute('data-i', oi);
            var n = api.el('span', 'crs-opt-n', String(pos + 1));
            b.appendChild(n);
            b.appendChild(api.richEl('span', null, opts[oi]));
            if (multi) b.setAttribute('aria-pressed', 'false');
            b.addEventListener('click', function () { pick(oi, b); });
            buttons.push(b);
            list.appendChild(b);
        });
        host.appendChild(list);
        var done = false;

        function reveal() {
            return right.map(function (i) { return opts[i]; }).join('; ');
        }
        function finish(sel) {
            done = true;
            buttons.forEach(function (b) {
                var i = +b.getAttribute('data-i');
                b.disabled = true;
                if (right.indexOf(i) >= 0) b.classList.add('is-right');
                else if (sel[i]) b.classList.add('is-wrong');
            });
            var selIdx = Object.keys(sel).filter(function (k) { return sel[k]; }).map(Number);
            var ok = selIdx.length === right.length && right.every(function (i) { return sel[i]; });
            var why = t.why && selIdx.length === 1 ? t.why[selIdx[0]] : null;
            var ex = [why, t.explain].filter(Boolean).join('\n\n');
            var score = ok ? 1 : 0;
            if (multi && !ok) {
                var hit = selIdx.filter(function (i) { return right.indexOf(i) >= 0; }).length;
                var wrong = selIdx.length - hit;
                score = Math.max(0, (hit - wrong) / right.length);
            }
            api.answer({ correct: ok, score: score, reveal: ok ? null : reveal(), explain: ex || null });
        }
        function pick(i, b) {
            if (done) return;
            if (!multi) { var s = {}; s[i] = true; finish(s); return; }
            picked[i] = !picked[i];
            b.classList.toggle('is-picked', picked[i]);
            b.setAttribute('aria-pressed', picked[i] ? 'true' : 'false');
            api.primaryEnabled(Object.keys(picked).some(function (k) { return picked[k]; }));
        }
        if (multi) api.primary(api.t('check'), function () { finish(picked); }, true);
        api.onKey(function (k) {
            var n = parseInt(k, 10);
            if (n >= 1 && n <= buttons.length) { buttons[n - 1].click(); return true; }
            return false;
        });
    }
    K.step('choice', { mount: choiceMount });
    K.step('multi', { mount: choiceMount });

    /* ── порядок: items — в ВЕРНОМ порядке, на экране перемешаны ───── */
    K.step('order', {
        mount: function (host, step, api) {
            var t = T(step);
            var items = t.items || [];
            prompt(host, api, t.prompt);
            api.figure(host);
            host.appendChild(api.el('p', 'crs-hint', api.t('order_hint')));
            var slots = api.el('ol', 'crs-slots');
            slots.setAttribute('aria-label', api.t('order_your'));
            var pool = api.el('div', 'crs-chips');
            host.appendChild(slots);
            host.appendChild(pool);
            var chosen = [];
            var poolOrder = api.shuffleApart(items.map(function (_, i) { return i; }));
            var chips = {};
            poolOrder.forEach(function (i) {
                var c = api.el('button', 'crs-chip');
                c.type = 'button';
                c.innerHTML = api.rich(items[i]);
                c.addEventListener('click', function () {
                    if (c.disabled) return;
                    chosen.push(i);
                    c.disabled = true;
                    draw();
                });
                chips[i] = c;
                pool.appendChild(c);
            });
            var locked = false;
            function draw() {
                slots.innerHTML = '';
                chosen.forEach(function (i, pos) {
                    var li = api.el('li', 'crs-slot');
                    li.appendChild(api.el('b', null, String(pos + 1)));
                    li.appendChild(api.richEl('span', null, items[i]));
                    li.setAttribute('role', 'button');
                    li.tabIndex = 0;
                    li.addEventListener('click', function () { if (!locked) remove(pos); });
                    li.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && !locked) { e.preventDefault(); remove(pos); } });
                    slots.appendChild(li);
                });
                api.primaryEnabled(chosen.length === items.length);
            }
            function remove(pos) {
                var i = chosen.splice(pos, 1)[0];
                chips[i].disabled = false;
                draw();
            }
            api.primary(api.t('check'), function () {
                locked = true;
                var right = 0;
                var lis = slots.querySelectorAll('.crs-slot');
                chosen.forEach(function (i, pos) {
                    var ok = i === pos;
                    if (ok) right++;
                    if (lis[pos]) lis[pos].classList.add(ok ? 'is-right' : 'is-wrong');
                });
                var all = right === items.length;
                api.answer({
                    correct: all,
                    score: items.length ? right / items.length : 1,
                    reveal: all ? null : items.map(function (x, k) { return (k + 1) + '. ' + x; }).join('\n')
                });
            }, true);
            draw();
        }
    });

    /* ── пары: pairs [[слева, справа], …] ─────────────────────────── */
    K.step('match', {
        mount: function (host, step, api) {
            var t = T(step);
            var pairs = t.pairs || [];
            prompt(host, api, t.prompt);
            api.figure(host);
            host.appendChild(api.el('p', 'crs-hint', api.t('match_hint')));
            var grid = api.el('div', 'crs-match');
            var colL = api.el('div', 'crs-chips');
            var colR = api.el('div', 'crs-chips');
            colL.style.flexDirection = colR.style.flexDirection = 'column';
            grid.appendChild(colL);
            grid.appendChild(colR);
            host.appendChild(grid);
            var leftOrder = api.shuffle(pairs.map(function (_, i) { return i; }));
            var rightOrder = api.shuffleApart(leftOrder);
            var L = {}, R = {};
            var link = {};   // left i → right j
            var color = {};  // left i → цвет
            var selL = null, selR = null, locked = false, nextColor = 0;
            function mk(col, side, i, text) {
                var c = api.el('button', 'crs-chip');
                c.type = 'button';
                c.innerHTML = api.rich(text);
                c.addEventListener('click', function () { if (!locked) tap(side, i); });
                col.appendChild(c);
                return c;
            }
            leftOrder.forEach(function (i) { L[i] = mk(colL, 'L', i, pairs[i][0]); });
            rightOrder.forEach(function (j) { R[j] = mk(colR, 'R', j, pairs[j][1]); });
            function unlinkLeft(i) { delete link[i]; delete color[i]; }
            function unlinkRight(j) { for (var i in link) if (link[i] === j) unlinkLeft(+i); }
            function tap(side, i) {
                if (side === 'L') {
                    if (link[i] != null) { unlinkLeft(i); selL = null; draw(); return; }
                    selL = selL === i ? null : i;
                } else {
                    var linked = false;
                    for (var x in link) if (link[x] === i) linked = true;
                    if (linked) { unlinkRight(i); selR = null; draw(); return; }
                    selR = selR === i ? null : i;
                }
                if (selL != null && selR != null) {
                    link[selL] = selR;
                    color[selL] = nextColor++ % 8;
                    selL = selR = null;
                }
                draw();
            }
            function draw() {
                pairs.forEach(function (_, i) {
                    var cl = L[i], cr = R[i];
                    cl.className = 'crs-chip' + (selL === i ? ' is-sel' : '');
                    cr.className = 'crs-chip' + (selR === i ? ' is-sel' : '');
                    cl.removeAttribute('data-pair');
                    cr.removeAttribute('data-pair');
                });
                for (var i in link) {
                    var c = color[i];
                    L[i].classList.add('crs-pair-' + c);
                    L[i].setAttribute('data-pair', c);
                    R[link[i]].classList.add('crs-pair-' + c);
                    R[link[i]].setAttribute('data-pair', c);
                }
                api.primaryEnabled(Object.keys(link).length === pairs.length);
            }
            api.primary(api.t('check'), function () {
                locked = true;
                var right = 0, wrong = [];
                pairs.forEach(function (p, i) {
                    var ok = link[i] === i;
                    if (ok) right++; else wrong.push(p[0] + ' — ' + p[1]);
                    L[i].classList.add(ok ? 'is-right' : 'is-wrong');
                    if (link[i] != null) R[link[i]].classList.add(ok ? 'is-right' : 'is-wrong');
                });
                api.answer({ correct: wrong.length === 0, score: pairs.length ? right / pairs.length : 1, reveal: wrong.length ? wrong.join('\n') : null });
            }, true);
            draw();
        }
    });

    /* ── ввод ответа: accept — нейтральные + языковые варианты ─────── */
    function norm(s, strict) {
        s = String(s == null ? '' : s).replace(/[‘’ʼ]/g, "'").replace(/[“”«»]/g, '"');
        s = s.replace(/\s+/g, ' ').trim().replace(/[.!?;,]+$/, '').trim();
        if (!strict) s = s.toLowerCase();
        return s;
    }
    K.step('fill', {
        mount: function (host, step, api) {
            var t = T(step);
            prompt(host, api, t.prompt);
            api.figure(host);
            audioButton(host, api, step);
            var row = api.el('div', 'crs-fill');
            var inp = api.el('input', 'lg-input');
            inp.type = step.numeric ? 'text' : 'text';
            if (step.numeric) inp.inputMode = 'decimal';
            inp.autocomplete = 'off';
            inp.setAttribute('autocapitalize', 'off');
            inp.spellcheck = false;
            inp.placeholder = t.placeholder || api.t('fill_placeholder');
            inp.setAttribute('aria-label', t.prompt ? String(t.prompt).replace(/\*/g, '') : api.t('fill_placeholder'));
            row.appendChild(inp);
            host.appendChild(row);
            var accept = (step.accept || []).concat(t.accept || []);
            var done = false;
            function check() {
                if (done) return;
                var v = inp.value;
                if (!String(v).trim()) return;
                done = true;
                inp.disabled = true;
                var ok;
                if (step.numeric) {
                    var x = parseFloat(String(v).replace(',', '.').replace(/[^\d.\-]/g, ''));
                    var tol = typeof step.tol === 'number' ? step.tol : 0;
                    ok = !isNaN(x) && accept.some(function (a) { return Math.abs(parseFloat(String(a).replace(',', '.')) - x) <= tol + 1e-9; });
                } else {
                    var nv = norm(v, step.strict);
                    ok = accept.some(function (a) { return norm(a, step.strict) === nv; });
                }
                api.answer({ correct: ok, reveal: ok ? null : (accept[0] != null ? String(accept[0]) : null) });
            }
            inp.addEventListener('input', function () { api.primaryEnabled(!!inp.value.trim()); });
            inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
            api.primary(api.t('check'), check, true);
            setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (_) {} }, 30);
        }
    });

    /* ── блиц «верно / неверно»: items + answers[bool], seconds — на утверждение ── */
    K.step('rapid', {
        mount: function (host, step, api) {
            var t = T(step);
            var items = t.items || [];
            var answers = step.answers || [];
            var secs = step.seconds || 0;
            prompt(host, api, t.prompt);
            var box = api.el('div', 'crs-rapid');
            var count = api.el('p', 'crs-hint');
            var timer = api.el('div', 'crs-timer');
            var tbar = api.el('span');
            timer.appendChild(tbar);
            var card = api.el('div', 'crs-rapid-card');
            card.setAttribute('aria-live', 'polite');
            var why = api.el('p', 'crs-rapid-why');
            var row = api.el('div', 'crs-rapid-row');
            var bt = api.el('button', 'lg-btn', '✓ ' + api.t('rapid_true'));
            var bf = api.el('button', 'lg-btn lg-btn-ghost', '✗ ' + api.t('rapid_false'));
            bt.type = bf.type = 'button';
            row.appendChild(bt);
            row.appendChild(bf);
            box.appendChild(count);
            if (secs) box.appendChild(timer);
            box.appendChild(card);
            box.appendChild(row);
            box.appendChild(why);
            host.appendChild(box);
            var i = 0, right = 0, wrong = [], busy = false, tm = null, anim = null;
            function stopTimer() {
                if (tm) { clearTimeout(tm); tm = null; }
                if (anim) { try { anim.cancel(); } catch (_) {} anim = null; }
            }
            api.onCleanup(stopTimer);
            function show() {
                busy = false;
                card.className = 'crs-rapid-card';
                why.textContent = '';
                count.textContent = api.t('rapid_count', { n: i + 1, total: items.length });
                card.innerHTML = api.rich(items[i]);
                bt.disabled = bf.disabled = false;
                if (secs) {
                    stopTimer();
                    try { anim = tbar.animate([{ transform: 'scaleX(1)' }, { transform: 'scaleX(0)' }], { duration: secs * 1000, fill: 'forwards' }); } catch (_) {}
                    tm = setTimeout(function () { pick(null); }, secs * 1000);
                }
            }
            function pick(v) {
                if (busy || !api.alive()) return;
                busy = true;
                stopTimer();
                bt.disabled = bf.disabled = true;
                var ok = v !== null && v === !!answers[i];
                if (ok) right++;
                else wrong.push((items[i] || '') + ' — ' + (answers[i] ? api.t('rapid_true') : api.t('rapid_false')) + (t.why && t.why[i] ? '. ' + t.why[i] : ''));
                card.classList.add(ok ? 'is-right' : 'is-wrong');
                why.textContent = v === null ? api.t('rapid_timeout') : (!ok && t.why && t.why[i] ? t.why[i] : (ok ? api.t('fb_right') : api.t('fb_wrong')));
                setTimeout(function () {
                    if (!api.alive()) return;
                    i++;
                    if (i < items.length) show();
                    else {
                        var score = items.length ? right / items.length : 1;
                        api.answer({ correct: score >= (step.pass || 0.8) - 1e-9, score: score, reveal: wrong.length ? wrong.join('\n') : null, explain: api.t('rapid_score', { n: right, total: items.length }) + (t.explain ? '\n\n' + t.explain : '') });
                    }
                }, ok ? 650 : 1900);
            }
            bt.addEventListener('click', function () { pick(true); });
            bf.addEventListener('click', function () { pick(false); });
            api.onKey(function (k) {
                if (k === '1' || k === 'arrowleft') { pick(true); return true; }
                if (k === '2' || k === 'arrowright') { pick(false); return true; }
                return false;
            });
            var started = false;
            api.primary(api.t('rapid_start'), function () {
                if (started) return;
                started = true;
                api.primary(null, null);
                show();
            });
            card.textContent = api.t('rapid_ready', { n: items.length });
            bt.disabled = bf.disabled = true;
        }
    });

    /* ── сценарий с выбором: nodes {id: {choices: [{to, good}], end}} ── */
    K.step('scenario', {
        mount: function (host, step, api) {
            var t = T(step);
            var nodes = step.nodes || {};
            var texts = t.nodes || {};
            if (t.title) host.appendChild(api.el('h3', null, t.title));
            api.figure(host);
            var scene = api.el('div', 'crs-scene');
            var log = api.el('div', 'crs-scene-log');
            var now = api.el('div', 'crs-scene');
            scene.appendChild(log);
            scene.appendChild(now);
            host.appendChild(scene);
            var good = 0, total = 0, guard = 0, tm = null;
            api.onCleanup(function () { if (tm) clearTimeout(tm); });
            function go(id) {
                if (!api.alive()) return;
                if (++guard > 40) { end(); return; }
                var n = nodes[id] || {};
                var tx = texts[id] || {};
                now.innerHTML = '';
                if (tx.text) now.appendChild(api.richEl('p', 'crs-scene-tx', tx.text));
                var ch = n.choices || [];
                if (n.end || !ch.length) { end(); return; }
                var list = api.el('div', 'crs-opts');
                var labels = tx.choices || [];
                var order = n.shuffle === false ? ch.map(function (_, i) { return i; }) : api.shuffle(ch.map(function (_, i) { return i; }));
                var buttons = [];
                var secs = n.seconds || step.seconds || 0;
                var timer = null;
                if (secs) {
                    var tb = api.el('div', 'crs-timer');
                    var sp = api.el('span');
                    tb.appendChild(sp);
                    now.appendChild(tb);
                    try { sp.animate([{ transform: 'scaleX(1)' }, { transform: 'scaleX(0)' }], { duration: secs * 1000, fill: 'forwards' }); } catch (_) {}
                }
                order.forEach(function (ci, pos) {
                    var b = api.el('button', 'crs-opt');
                    b.type = 'button';
                    b.appendChild(api.el('span', 'crs-opt-n', String(pos + 1)));
                    b.appendChild(api.richEl('span', null, labels[ci] || ''));
                    b.addEventListener('click', function () { choose(ci); });
                    buttons.push(b);
                    list.appendChild(b);
                });
                now.appendChild(list);
                var chosen = false;
                function choose(ci) {
                    if (chosen) return;
                    chosen = true;
                    if (tm) { clearTimeout(tm); tm = null; }
                    var c = ci === null ? null : ch[ci];
                    var ok = !!(c && c.good);
                    total++;
                    if (ok) good++;
                    var line = api.el('p', ok ? 'is-good' : 'is-bad');
                    var said = ci === null ? api.t('scene_timeout') : (labels[ci] || '');
                    var fbk = ci === null ? '' : ((tx.feedback && tx.feedback[ci]) || '');
                    line.innerHTML = '<b>' + api.rich(said) + '</b>' + (fbk ? '<br>' + api.rich(fbk) : '');
                    log.appendChild(line);
                    var to = c ? c.to : (n.timeout || null);
                    if (to) go(to); else if (ci === null) { chosen = false; go(id); } else end();
                }
                if (secs) tm = setTimeout(function () { choose(null); }, secs * 1000);
                api.onKey(function (k) {
                    var x = parseInt(k, 10);
                    if (x >= 1 && x <= buttons.length) { buttons[x - 1].click(); return true; }
                    return false;
                });
            }
            function end() {
                var score = total ? good / total : 1;
                api.answer({ correct: total ? good === total : null, score: score, explain: t.explain || null });
            }
            go(step.start || 'start');
        }
    });

    /* ── найди на рисунке: spots [{x, y, r}] в % ширины и высоты рисунка ── */
    K.step('hotspot', {
        mount: function (host, step, api) {
            var t = T(step);
            var spots = step.spots || [];
            var labels = t.spots || [];
            prompt(host, api, t.prompt);
            var fig = api.el('div', 'crs-fig');
            var wrap = api.el('div', 'crs-hot');
            fig.appendChild(wrap);
            host.appendChild(fig);
            var f = step.figure || {};
            if (f.svg) { wrap.innerHTML = f.svg; }
            else if (f.img) { var im = api.el('img'); im.src = f.img; im.alt = t.figure_alt || ''; wrap.appendChild(im); }
            var count = api.el('p', 'crs-hint');
            host.appendChild(count);
            var found = {}, misses = 0, done = false;
            var list = api.el('ul', 'crs-hot-list');
            host.appendChild(list);
            var btns = spots.map(function (s, i) {
                var b = api.el('button', 'crs-hot-spot');
                b.type = 'button';
                b.style.left = s.x + '%';
                b.style.top = s.y + '%';
                b.style.width = (s.r * 2) + '%';
                b.style.aspectRatio = '1 / 1';
                b.setAttribute('aria-label', api.t('spot_n', { n: i + 1 }));
                b.addEventListener('click', function (e) {
                    e.stopPropagation();
                    if (done || found[i]) return;
                    found[i] = true;
                    b.classList.add('is-found');
                    if (labels[i]) list.appendChild(api.richEl('li', null, labels[i]));
                    update();
                });
                wrap.appendChild(b);
                return b;
            });
            wrap.addEventListener('click', function (e) {
                if (done) return;
                var r = wrap.getBoundingClientRect();
                if (!r.width) return;
                misses++;
                var m = api.el('span', 'crs-hot-spot is-miss');
                m.style.left = ((e.clientX - r.left) / r.width * 100) + '%';
                m.style.top = ((e.clientY - r.top) / r.height * 100) + '%';
                m.style.width = '6%';
                m.style.aspectRatio = '1 / 1';
                m.style.pointerEvents = 'none';
                wrap.appendChild(m);
                setTimeout(function () { try { m.remove(); } catch (_) {} }, 900);
                update();
            });
            function update() {
                var n = Object.keys(found).length;
                count.textContent = api.t('spot_found', { n: n, total: spots.length });
                if (misses >= 2 && !done) api.secondary(api.t('spot_giveup'), giveUp);
                if (n === spots.length) finish(false);
            }
            function giveUp() {
                spots.forEach(function (_, i) {
                    if (!found[i]) {
                        btns[i].classList.add('is-show');
                        if (labels[i]) list.appendChild(api.richEl('li', null, labels[i]));
                    }
                });
                finish(true);
            }
            function finish(gave) {
                if (done) return;
                done = true;
                var n = Object.keys(found).length;
                var score = spots.length ? Math.max(0, n / spots.length - misses * 0.1) : 1;
                api.answer({ correct: !gave && misses <= (step.allow != null ? step.allow : 2), score: score, explain: t.explain || null });
            }
            update();
        }
    });

    /* ── практика: таймер, счёт повторов, метроном, зеркало-камера ─── */
    K.step('practice', {
        graded: false,
        mount: function (host, step, api) {
            var t = T(step);
            var box = api.el('div', 'crs-practice');
            if (t.title) box.appendChild(api.el('h3', null, t.title));
            host.appendChild(box);
            api.figure(box);
            api.body(box, t.body || []);
            tipsBox(box, api, t.tips);
            noteBox(box, api, t.note);
            var video = null;
            if (step.mirror) {
                video = api.el('video', 'crs-mirror');
                video.muted = true;
                video.playsInline = true;
                video.setAttribute('playsinline', '');
                video.autoplay = true;
                video.hidden = true;
                box.appendChild(video);
            }
            var big = api.el('div', 'crs-big');
            var secs = step.seconds || 0;
            var reps = step.reps || 0;
            if (secs) big.textContent = fmtTime(secs);
            else if (reps) big.textContent = '0 / ' + reps;
            if (secs || reps) box.appendChild(big);
            var repBtn = null, repN = 0;
            if (reps) {
                repBtn = api.el('button', 'lg-btn lg-btn-ghost', '+1');
                repBtn.type = 'button';
                repBtn.disabled = true;
                repBtn.addEventListener('click', function () {
                    repN++;
                    big.textContent = repN + ' / ' + reps;
                    if (repN >= reps && !secs) ready();
                });
                box.appendChild(repBtn);
            }
            var iv = null, metro = null;
            api.onCleanup(function () { if (iv) clearInterval(iv); if (metro) metro.stop(); });
            function fmtTime(s) {
                s = Math.max(0, Math.ceil(s));
                return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
            }
            function ready() {
                if (iv) { clearInterval(iv); iv = null; }
                if (metro) { metro.stop(); metro = null; }
                api.tone(['E5', 'A5'], { bpm: 300 }).catch(function () {});
                if (repBtn) repBtn.disabled = true;
                api.secondary(null, null);
                if (step.selfcheck === false) { api.primary(api.t('next'), function () { api.answer({ correct: null }); }); return; }
                selfCheck();
            }
            function selfCheck() {
                var q = api.el('p', 'crs-prompt', t.done_q || api.t('self_q'));
                box.appendChild(q);
                var row = api.el('div', 'crs-self');
                [['self_yes', 1], ['self_almost', 0.5], ['self_no', 0]].forEach(function (x) {
                    var b = api.el('button', 'lg-btn lg-btn-ghost', api.t(x[0]));
                    b.type = 'button';
                    b.addEventListener('click', function () {
                        api.store.set('self:' + step._lesson + '/' + step.id, x[1]);
                        var msg = x[1] === 1 ? (t.after_yes || api.t('self_yes_tx')) : x[1] === 0.5 ? (t.after_almost || api.t('self_almost_tx')) : (t.after_no || api.t('self_no_tx'));
                        api.answer({ correct: null, explain: msg });
                    });
                    row.appendChild(b);
                });
                box.appendChild(row);
                api.primary(null, null);
            }
            function start() {
                api.primary(null, null);
                api.secondary(api.t('practice_finish'), ready);
                if (repBtn) repBtn.disabled = false;
                if (video) {
                    api.mic({ video: { facingMode: 'user', width: { ideal: 640 } }, audio: false }).then(function (s) {
                        if (!api.alive()) return;
                        video.srcObject = s;
                        video.hidden = false;
                        var p = video.play();
                        if (p && p.catch) p.catch(function () {});
                    }, function (e) {
                        box.appendChild(api.el('p', 'crs-hint', api.t('camera_off')));
                    });
                }
                if (step.metronome) metro = metronome(step.metronome);
                if (secs) {
                    var end = Date.now() + secs * 1000;
                    iv = setInterval(function () {
                        var left = (end - Date.now()) / 1000;
                        big.textContent = fmtTime(left);
                        if (left <= 0) ready();
                    }, 200);
                }
                if (!secs && !reps) ready();
            }
            function metronome(bpm) {
                var stop = false, nextT = 0, timer = null;
                api.audioCtx().then(function (ctx) {
                    nextT = ctx.currentTime + 0.1;
                    timer = setInterval(function () {
                        if (stop) return;
                        while (nextT < ctx.currentTime + 0.25) {
                            var o = ctx.createOscillator(), g = ctx.createGain();
                            o.frequency.value = 1500;
                            g.gain.setValueAtTime(0.0001, nextT);
                            g.gain.exponentialRampToValueAtTime(0.3, nextT + 0.002);
                            g.gain.exponentialRampToValueAtTime(0.0001, nextT + 0.05);
                            o.connect(g); g.connect(ctx.destination);
                            o.start(nextT); o.stop(nextT + 0.06);
                            nextT += 60 / bpm;
                        }
                    }, 60);
                }).catch(function () {});
                return { stop: function () { stop = true; if (timer) clearInterval(timer); } };
            }
            api.primary(t.start || api.t('practice_start'), start);
            api.secondary(api.t('skip'), function () { api.skip(); });
        }
    });
})();
